import React, { useState,useEffect } from 'react';
import MatchingCandidatesList from './matchingCandidatesList';
import JobDetailsPanel from './jobDetailsPanel';

const MatchingCandidatesPage = ({
    onCandidateSelect,
    matchingCandidates,
    jobDetails,
    candidateActiveTab,
    isFirst = 0 ,
    onUpdateCandidate// <-- Accept isFirst as a prop
}) => {
    const [isOpen, setIsOpen] = useState(true);
    const handleMatchingCandidateClick = (candidate, activeTab) => {
        onCandidateSelect(candidate, activeTab);
    };
    useEffect(() => {
  const handleResize = () => {
    if (window.innerWidth < 1320) {
      setIsOpen(false); 
    }
  };

  // Check on mount
  handleResize();

  // Add event listener
  window.addEventListener('resize', handleResize);

  // Cleanup
  return () => window.removeEventListener('resize', handleResize);
}, []);

    return (
        <div className="flex-1 w-full flex flex-col ">
             <button
          onClick={() => setIsOpen(!isOpen)}
          className="fixed right-[42px] top-1/2 transform -translate-y-1/2 bg-gradient text-white p-2 rounded-full shadow-lg hover:shadow-xl z-10"
          title={
            isOpen
              ? "Hide Other Candidates"
              : "Show Other Candidates"
          }
        >
          <svg
            className="w-5 h-5"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            style={{
              transform: !isOpen ? "rotate(180deg)" : "rotate(0deg)",
              transition: "transform 0.3s",
            }}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round" 
              strokeWidth={2}
              d="M15 19l-7-7 7-7"
            />
          </svg>
        </button>
            <div className="flex-1 grid grid-cols-1 lg:grid-cols-3 gap-8 px-8 pb-8 min-h-0">
              <div className={`h-[calc(100vh-9rem)] anim-slideRight transition-all duration-300 ${isOpen ? 'lg:col-span-2' : 'lg:col-span-3'}`}>
                    <MatchingCandidatesList
                        pageType="matching"
                        onMatchingCandidateClick={handleMatchingCandidateClick}
                        onUpdateCandidate={onUpdateCandidate}
                        candidates={matchingCandidates}
                        mph_jobid={jobDetails.mph_jobid}
                        job_id={jobDetails.id}
                        candidateActiveTab={candidateActiveTab}
                        jobDetails={jobDetails}
                        isFirst={isFirst} // <-- Pass isFirst to MatchingCandidatesList
                    />
                </div>
                <div className={`lg:col-span-1 h-[calc(100vh-9rem)] anim-slideLeft transition-all duration-300 ${!isOpen ? 'w-0 overflow-hidden' : 'w-auto'}`}>
                    <JobDetailsPanel jobDetails={jobDetails} />
                </div>
            </div>
        </div>
    );
};

export default MatchingCandidatesPage;